import * as React from "react"

export function useScrollY() {
  const [scroll, setScroll] = React.useState(scrollY)
  React.useEffect(() => {
    const listener = () => setScroll(scrollY)
    document.addEventListener("scroll", listener)
    return () => document.removeEventListener("scroll", listener)
  }, [document])
  return scroll
}
